import { styled } from '@mui/system';
import { Container } from '../../../../../components/Grid';

export default styled(Container)({
  width: 'auto !important',
  margin: '0 -2.5rem 0 -2.5rem',
  padding: '0rem 2.5rem',
});
